/* @flow strict */

import * as React from 'react';
import Modal from './../Modal';
import './styles.scss';

type PropsType = {
  type: string,
  title: string,
  content: string | React.Node,
  data?: {
    setEventStatus?: (boolean) => void,
    eventStatus?: boolean
  },
  handleShow: (boolean) => void,
  callback?: boolean | (any) => void,
  cancelCallback?: boolean | (any) => void,
  actionOkText?: string
};

const SystemDialog = (
  { type, title, content, data, handleShow, callback, cancelCallback, actions, actionOkText }: PropsType
): React.Element<'div'> => {
  if (type === 'success') {
    setTimeout(() => {
      handleShow(false);
    }, 2000);
  }

  return (
    <Modal
      opened
      onClose={() => {
        handleShow(false);
      }}
      isSystem
    >
      <div className="modal-dialog customModal ConfirmDialog" role="document">
        <div className="modal-content">
          <div className={`sparxo-pop md-content ${type}`}>
            <div className="sparxo-pop-left" />

            <div className="sparxo-pop-right">
              <h3 className="sparxo-pop-title">{title}</h3>

              <div className={`sparxo-pop-content ${type}`}>
                {content}
              </div>

              {(type === 'error' && !callback) &&
                <div className="sparxo-pop-buttons">
                  <button
                    className="btn-pink"
                    onClick={() => {
                      handleShow(false);
                    }}
                  >
                    Ok
                  </button>
                </div>
              }

              {callback &&
                <div className="sparxo-pop-buttons">
                  {!actions || actions && _.includes(actions, 'Cancel') &&
                    <button
                      className="btn-gray"
                      onClick={() => {
                        handleShow(false);

                        if (cancelCallback) {
                          cancelCallback();
                        }
                      }}
                    >
                      No
                    </button>
                  }

                  {!actions || actions && _.includes(actions, 'Ok') &&
                    <button
                      className="btn-pink"
                      onClick={() => {
                        handleShow(false);

                        callback(false, () => {
                          data.setEventStatus(!data.eventStatus);
                        });
                      }}
                    >
                      { !!actionOkText ? actionOkText : 'Yes'}
                    </button>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default SystemDialog;
